/**
 * SEO Component
 * Provides dynamic meta tags for each page using react-helmet-async
 */

import { Helmet } from 'react-helmet-async';

const defaultMeta = {
  title: 'LumiSkating - Olympic-Level Figure Skating AI Assistant',
  description: 'AI figure skating coach that analyzes your technique with 33-point pose detection. Get personalized training feedback, ISU scoring insights, and Olympic-level coaching — your AI figure skating training assistant.',
  url: 'https://www.lumiskating.com',
  image: 'https://www.lumiskating.com/og-image.png',
  twitterImage: 'https://www.lumiskating.com/twitter-image.png',
  type: 'website',
};

function SEO({
  title,
  description,
  url,
  image,
  twitterImage,
  type = 'website',
  noindex = false,
}) {
  const seo = {
    title: title || defaultMeta.title,
    description: description || defaultMeta.description,
    url: url || defaultMeta.url,
    image: image || defaultMeta.image,
    twitterImage: twitterImage || image || defaultMeta.twitterImage,
    type: type || defaultMeta.type,
  };

  // Append site name to title if not already the default
  const fullTitle = title && !title.includes('LumiSkating')
    ? `${title} | LumiSkating`
    : seo.title;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={seo.url} />

      {/* Robots */}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={seo.type} />
      <meta property="og:url" content={seo.url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.twitterImage} />
    </Helmet>
  );
}

export default SEO;
